<template>

    <header>
        <div class="header_top">
            <div class="center">
                <div>
                    {{ welcomeMsg }}
                </div>
                <div>
                    <span>登录</span>
                    <span class="thick_line">注册</span>
                    <span>帮助中心</span>
                    <span>询价单</span>
                    <span>意见反馈</span>
                    <span @click="routeTo('/displayPage','home')">编辑</span>
                </div>
            </div>
        </div>
        <div class="header_search">
            <div class="center">
                <span @click="routeTo('/','')">
                    <img src="../../public/images/logo210_70.png">
                </span>
                <div>
                    <span><input type="text"></span>
                    <span>搜索</span>
                </div>
                <span class="cart">
                    购物车
                    <div class="cart_list">
                        <div v-for="(v,i) in carList" :key="i">{{ v }}</div>
                        <div v-show="carList.length == 0">您的购物车还没有任何商品</div>
                    </div>
                </span>
            </div>
        </div>
    </header>

</template>

<script>
export default{
    name:"homeHeader",
    data(){
        return{
            welcomeMsg:"您好，欢迎光临印特丽！ 客服热线：020-37092033",
            carList:[]
        }
    },
    methods:{
        routeTo(link,param){
            if(param!=""){
                this.$router.push({ path: link+'/'+param });
            }else{
                this.$router.push(link);
            }
        }
    }
}
</script>

<style lang="less" scoped>

header{
    width: 100%;
    background-color: #c41b20;
    color: white;
    .header_top{
        width: 100vw;
        height: 36px;
        border-bottom: 1px solid #fff;
        position: fixed;
        left: 0;
        top: 0;
        background-color: #c41b20;
        z-index: 99;
        .center{
            height: 36px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            >div{
                &:last-child{
                    span{
                        padding: 0 12px;
                        position: relative;
                        cursor: pointer;
                        &:hover{
                            color: #fdedb9;
                        }
                        &::after{
                            content: "";
                            width: 1px;
                            height: 12px;
                            background-color: white;
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translate(-50%,-50%);
                        }
                        &:last-child::after{
                            content: none;
                        }
                    }
                    >.thick_line::after{
                        width:2px;
                    }
                }
            }
        }
        
    }

    .header_search{
        padding: 41px 0 4px 0;
        .center{
            display: flex;
            justify-content: space-between;
            align-items: center;
            >div{
                display: flex;
                align-items: center;
                span{
                    display: inline-block;
                    input{
                        height: 30px;
                        border: 2px solid #fff;
                        outline: none;
                        background-color: #c41b20;
                        width: 380px;
                        border-top-left-radius: 5px;
                        border-bottom-left-radius: 5px;
                        color: #fff;
                        padding: 0 8px;
                        font-weight: 600;
                    }
                    &:last-child{
                        background-color: #fff;
                        color: #c41b20;
                        height: 34px;
                        line-height: 34px;
                        width: 100px;
                        border-top-right-radius: 5px;
                        border-bottom-right-radius: 5px;
                    }
                }
            }
            >span{
                &:last-child{
                    font-size: 18px;
                    font-weight: bold;
                    margin-right: 160px;
                    height: 50px;
                    line-height: 50px;
                    position: relative;
                    &::before{
                        content: "";
                        position: absolute;
                        width: 40px;
                        height: 34px;
                        left: 0;
                        top: 50%;
                        transform: translate(-100%,-50%);
                        background-image: url("../../public/images/icon_1.png");
                        background-repeat: no-repeat;
                        background-position: -10px 2px;
                    }
                    >.cart_list{
                        position: absolute;
                        background-color: #fff;
                        display: none;
                        color: black;
                        padding: 10px;
                        bottom: 6px;
                        right: 0;
                        transform: translate(0,100%);
                        font-size: 14px;
                        z-index: 99;
                        >div{
                            &:last-child{
                                width: 300px;
                            }
                        }
                    }
                    &:hover>.cart_list{
                        display: block;
                    }
                }
            }
        }
    }
}



</style>